import MedicalInstitutionLine from "./MedicalInstitutionLine"

export default MedicalInstitutionLine